module.exports = __webpack_public_path__ + "static/img/taxi_logo_small.a7ccf511.png";